import { keyframes, style } from "@vanilla-extract/css";
import { calc } from "@vanilla-extract/css-utils";
import styles from "plos/src/components/links/Link/Link.module.css";
import { vars } from "plos/src/styles";

const slideInFromBottom = keyframes({
  from: {
    transform: "translateY(50px)",
    opacity: 0,
  },
  to: {
    transform: "translateY(0)",
    opacity: 1,
  },
});

export const onboarding = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  padding: `0 ${vars.space.m} ${vars.space.m} ${vars.space.m}`,
  animation: `${slideInFromBottom} 300ms ease-out`,
});

export const subtitleStyles = style({
  marginTop: calc.negate(vars.space.s),
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.l,
});

export const autoPickChoiceSubtitle = style({
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.l,
});

export const termsLink = style([
  styles.link,
  { display: "inline", alignSelf: "flex-start" },
]);

export const onboardingHeading = style({
  fontSize: vars.fontSizes.heading.l,
});

export const onboardingTitle = style({
  fontSize: vars.fontSizes.heading.xl,
});
